import { createContext } from 'react'
import { ModalContextTypes } from './modalsCtx.interface'

const modalsCtx = createContext<ModalContextTypes>({
  showConfirmationModal: false,
  showTaskModal: false,
  modalText: null,
  resourceId: null,
  isOpen: false,
  selectedTask: undefined,
  setIsOpen: () => {},
  closeTaskModalHandler: () => {},
  closeConfirmationModalHandler: () => null,
  openConfirmationModalHandler: () => null,
  openTaskModalHandler: () => null
})

export default modalsCtx
